@let buttonClasses =
    'inline-flex h-full items-center justify-center align-middle text-base rounded-full border-0 bg-transparent p-0 hover:text-[var(--element-ui-1)] active:text-[var(--element-ui-1)] disabled:text-[var(--element-text-disabled)]';

@if (mode() === 'tooltip') {
    <button
        type="button"
        [class]="buttonClasses + ' text-[var(--element-ui-2)]'"
        [attr.aria-label]="ariaLabel() || title() | translate"
        [siTooltip]="contentTemplate() ?? (contentText() | translate)"
        [placement]="placement()"
    >
        <si-icon [icon]="icons.elementHelp" />
    </button>
} @else {
    <button
        type="button"
        [class]="buttonClasses + ' text-[var(--element-ui-0)]'"
        [attr.aria-label]="ariaLabel() || title() | translate"
        [siTooltip]="'help.more-info' | translate"
        [placement]="placement()"
        (click)="openDialog()"
    >
        <si-icon [icon]="icons.elementHelp" />
    </button>
}

<ng-template #dialog>
    @if (dialogTemplate(); as customDialog) {
        <ng-container [ngTemplateOutlet]="customDialog" [ngTemplateOutletContext]="dialogContext" />
    } @else {
        <div class="modal-header">
            <h4 class="modal-title">{{ title() | translate }}</h4>
            <button
                type="button"
                class="btn btn-circle btn-ghost element-cancel btn-lg"
                [attr.aria-label]="closeLabel() | translate"
                (click)="closeDialog()"
            ></button>
        </div>
        <div class="modal-body">
            @if (contentTemplate(); as template) {
                <ng-container [ngTemplateOutlet]="template" />
            } @else {
                {{ contentText() | translate }}
            }
        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-secondary" (click)="closeDialog()">
                {{ closeLabel() | translate }}
            </button>
        </div>
    }
</ng-template>
